import { PublicClientApplication } from "@azure/msal-browser";

const msalConfig = {
  auth: {
    clientId: "43308b84-c30f-44c8-8c9f-85ad56b59723", // Replace with your Client ID
    authority: "https://login.microsoftonline.com/b8869792-ee44-4a05-a4fb-b6323a34ca35", // Replace with your Tenant ID
    redirectUri: `${window.location.origin}/auth/aad-redirect`,
    navigateToLoginRequestUrl: false
  },
  cache: {
    cacheLocation: "localStorage", // Persist login across sessions
    storeAuthStateInCookie: true, // Improves token persistence in incognito/private mode
  },
  system: {
    tokenRenewalOffsetSeconds: 300, // Renew token 5 minutes before expiry
  }
};

export const msalInstance = new PublicClientApplication(msalConfig);

// ✅ Ensure MSAL is initialized before usage
msalInstance.initialize().catch((error) => {
  console.error("MSAL Initialization Error:", error);
});

export default msalInstance;